/**
 * Item 28: stop browser password managers (e.g. BRC's Password Vault) from offering saved
 * logins/addresses in the app's form fields. Each field gets the "ignore this field"
 * markers the common managers respect (LastPass, 1Password, Bitwarden, Dashlane).
 * autocomplete="off" is deliberately NOT set: it also turned off the browser's own
 * suggestions of values the user typed before, which users rely on.
 * Applied app-wide by watching the DOM, so every current and future field is covered.
 */
const ATTRS: Record<string, string> = {
  'data-lpignore': 'true',   // LastPass
  'data-1p-ignore': 'true',  // 1Password
  'data-bwignore': 'true',   // Bitwarden
  'data-form-type': 'other', // Dashlane
};

function mark(el: Element) {
  for (const [k, v] of Object.entries(ATTRS)) {
    if (el.getAttribute(k) !== v) el.setAttribute(k, v);
  }
}

function markAll(root: ParentNode) {
  root.querySelectorAll('input, textarea, select, form').forEach(mark);
}

export function disableAutofill(): void {
  markAll(document);
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((n) => {
        if (n instanceof Element) {
          if (n.matches('input, textarea, select, form')) mark(n);
          markAll(n);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
}
